import FlashSvg from './flash.svg'
import {SvgIcon, SvgIconProps} from '@mui/material'

export const FlashIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon
            component={FlashSvg}
            viewBox="0 0 146 28"
            sx={{width: 140, height: 'auto'}}
            inheritViewBox
            {...props}
        />
    )
}
